import React from "react"
import { ImSpinner2 } from "react-icons/im"
import { FaExclamationTriangle } from "react-icons/fa"

const PageStatus = ({ loading, error, loadingText = "Loading data..." }) => {
    if (loading) {
        return (
            <div className="flex flex-col items-center justify-center h-40 text-gray-500 text-sm">
                <ImSpinner2 className="animate-spin text-2xl mb-2" />
                <p>{loadingText}</p>
            </div>
        )
    }

    if (error) {
        return (
            <div className="flex flex-col items-center justify-center h-40 text-red-500 text-sm font-semibold">
                <FaExclamationTriangle className="text-2xl mb-2" />
                <p className="tracking-wide">{error}</p>
            </div>
        )
    }

    return null
}

export default PageStatus